import { CONSTANTS } from './vars';

export default async function removeWishlist(handle) {
  try {
    const wishlist = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY);
    const wishlistArray = wishlist ? wishlist.split(CONSTANTS.LOCAL_STORAGE_DELIMITER) : [];
    const productIndex = wishlistArray.indexOf(handle);

    if (productIndex !== -1) {
      wishlistArray.splice(productIndex, 1);
      localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlistArray.join(CONSTANTS.LOCAL_STORAGE_DELIMITER));
      document.dispatchEvent(new CustomEvent('wishlist:removed', { detail: { handle } }));
    }
  } catch (e) {
    console.log('[Wishlist] remove error', e);
  }
}
